import { IoClose } from "react-icons/io5";
import styled from "styled-components";

const sizes = {
  mobileL: "500px",
  tablet: "768px",
  laptop: "1024px",
  laptopLdesktop: "1200px",
};

export const devices = {
  mobileL: `(min-width: ${sizes.mobileL})`,
  tablet: `(min-width: ${sizes.tablet})`,
  laptop: `(min-width: ${sizes.laptop})`,
  laptopLdesktop: `(min-width: ${sizes.laptopLdesktop})`,
};

export const Background = styled.div<{ marginTop: boolean, isDesktop: boolean }>`
  width: 100%; 
  background-color: var(--color-blue-50);
  margin-top: ${({ marginTop }) => (marginTop ? "35px" : "0px")};
  @media ${devices.laptop} {
    margin-top: 0px;
  }
  ${({isDesktop}) => (isDesktop && "display: flex;" )};
   ${({isDesktop}) => (isDesktop && "justify-content: center;" )};
`;

export const OIcontainer = styled.div`
  margin-top: -20px;
`;

export const Wrapper = styled.div<{isDesktop: boolean}>`
  max-width: 100%;
  padding: 20px 0px; 
  width: 95%;
  position: relative;
  font-size: var(--font-size-xlarge);
  ${({isDesktop}) => (!isDesktop && "margin-left: auto;" )};
  ${({isDesktop}) => (!isDesktop && "margin-right: auto;" )};

  @media ${devices.mobileL} {
    max-width: 90%;
  }

  @media ${devices.laptop} {
    max-width: 70%;
    font-size: var(--font-size-body);
  }

  @media ${devices.laptopLdesktop} {
    max-width: 800px;
    min-width: 800px;
    width: 40%;
  }
`;

export const WrapperWhenBanner = styled.div<{ show: boolean }>`
  margin-top: ${({ show }) => (show === true ? "100px" : "0px")};
  @media ${devices.laptop} {
    margin-top: ${({ show }) => (show === true ? "211px" : "0px")};
  }
`;

export const AccordionWrapper = styled.div`
  width: 95%;
  margin-right: auto;
  margin-left: auto;
  padding: 15px 0px;
`;

export const StepHeader = styled.button`
  background-color: #cecece;
  border: 1px solid #000000;
  border-top-radius: 10px;
  width: 100%;
`;

export const StepContent = styled.div`
  background-color: #ffffff;
  border: 1px solid #000000;
`;

export const CampaignImgDiv = styled.div`
  position: absolute;
  height: 126px;
  width: 100%;
  @media ${devices.laptop} {
    height: 275px;
  }
`;

export const CampaignImgBg = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--color-petrol);
  position: releative;
  display: flex;
  justify-content: center;
`;

export const CampaignImg = styled.img`
  height: 146px;
  width: auto;
  position: absolute;
  margin-top: -20px;
  @media ${devices.laptop} {
    height: 308px;
    margin-top: -34px;
  }
`;

export const GiftcardWrapper = styled.div`
  background-color: var(--color-blue-50);
`;

export const GiftcardWidth = styled.div`
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 8px;

  @media ${devices.mobileL} {
    max-width: 90%;
  }

  @media ${devices.laptop} {
    max-width: 70%;
    font-size: var(--font-size-body);
  }

  @media ${devices.laptopLdesktop} {
    max-width: 800px;
    min-width: 800px;
    width: 40%;
  }
`;